<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="-two-columns">


            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>


            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Hébergements / Hôtels</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            @set-search-text="setSearchText('searchAccommodationText', $event)"
                            :deletedShowable="true"
                            :showDeleted="showDeleted"
                            @set-show-deleted="showDeleted = $event"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary" v-else-if="form.id && !form.deleted_at">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h2 class="o-form__title">Hébergements / Hôtels</h2> -->
                            <input v-if="form.id" type="hidden" v-model="form.id" />
                            <div class="o-form__item full-width q-mb-lg">
                                <Input
                                    v-model="form.name"
                                    placeholder="Nom de l'établissement"
                                    label="Nom"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>

                            <div class="o-form__item">
                                <Input
                                    v-model="form.primary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone principal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.secondary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone secondaire"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.fax"
                                    placeholder="(111) 111-1111"
                                    label="Télécopieur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.website"
                                    placeholder="https://votresite.com"
                                    label="Site Internet"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="url"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.street"
                                    placeholder="Rue"
                                    label="Adresse"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.town"
                                    placeholder="Ville"
                                    label="Ville"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.state"
                                    placeholder="Ex. Qc"
                                    label="Province"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.country"
                                    placeholder="Pays"
                                    label="Pays"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.zipcode"
                                    placeholder="Ex. A1A 1A1"
                                    label="Code postal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.email"
                                    placeholder=""
                                    label="Courriel"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="email"
                                />
                            </div>

                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.note"
                                    placeholder="Note"
                                    label="Note"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    type="textarea"
                                    v-model="form.internal_notes"
                                    placeholder="Note interne"
                                    label="Note interne"
                                    autogrow
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                                <q-item-label caption class="q-mt-sm">
                                    Les notes internes ne sont pas visibles que par un administrateur.
                                </q-item-label>

                            </div>
                        </fieldset>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ACCOMMODATIONS, ACCOMMODATIONSSEARCH } from '@/graphql/accommodation/queries'
    import { UPSERTACCOMMODATION, DELETEACCOMMODATION, RESTOREREACCOMMODATION } from '@/graphql/accommodation/mutations'
    import { removeNULL, remove__typename } from '@/js/utilities'
// AccommodationCategoryInput
    export default {
        name: 'accommodations',
        apollo: {
            accommodations: {
                query: ACCOMMODATIONS,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(accommodations) {
                    this.listbox.listItems = Object.assign([], accommodations.accommodations.data)
                    this.listbox.listItems.forEach(item => {
                        if(item.categories && item.categories.length>0) item.color = item.categories[0].color;
                    });
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchAccommodationText: null,
                form: {},
                perPage: 50,
                showDeleted: false,

                newItem: {
                    // id: 0,
                    // name: null,
                    // primary_phone: null,
                    // secondary_phone: null,
                    // fax: null,
                    // street: null,
                    // town: null,
                    // state: null,
                    // country: null,
                    // zipcode: null,
                    // website: null,
                },
            }
        },
        mounted: async function(){
            this.listbox.selectedItem=Object.assign({}, this.newItem);
            this.form=Object.assign({}, this.newItem);
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form = remove__typename(Object.assign({}, item));
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);
                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETEACCOMMODATION,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.accommodations) this.$apollo.queries.accommodations.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                form = removeNULL(form);
                if (form.categories) form.categories = form.categories.map(item => item.id);
                this.$apollo.mutate({
                    mutation: UPSERTACCOMMODATION,
                    variables: { ...form },
                    update: (store, { data: { upsertAccommodation } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            const data = store.readQuery({ query: ACCOMMODATIONS, variables: myVariables })
                            data.accommodations.data.push(upsertAccommodation);
                            store.writeQuery({
                                query: ACCOMMODATIONS,
                                data,
                            })
                        }
                        this.setSelected(upsertAccommodation);
                    }
                }).then((/*data*/) => {
                    this.$q.notify({type: 'positive', message: "Companie : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTOREREACCOMMODATION,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreAccommodation } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: ACCOMMODATIONS })
                            data.accommodations.push(restoreAccommodation);
                            store.writeQuery({
                                query: ACCOMMODATIONS,
                                data,
                            })
                        }
                        this.setSelected(restoreAccommodation)
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Établissement : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            },
            setSearchText(prop, searchText) {
                this.setSelected(this.newItem);
                if (searchText && searchText.length > 1) searchText = searchText.trim().split(" ").join("* ") + "*";
                this.fetchSearchText(searchText);
            },
            async fetchSearchText(searchText) {

                if (searchText && searchText != "") {
                    if (this.$apollo.queries.accommodationsSearch) {
                        this.$apollo.queries.accommodationsSearch.options.variables.searchText = searchText;
                        this.$apollo.queries.accommodationsSearch.refresh();
                    } else {

                        let search = searchText.trim().split(" ").join("* ") + "*";
                        search = search.replace(/\*\*/g, '*');

                        this.$apollo.addSmartQuery('accommodationsSearch', {
                            query: ACCOMMODATIONSSEARCH,
                            fetchPolicy: 'network-only',
                            error(error) {
                                if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                            },
                            variables: {
                                searchText: search,
                                // trashed: this.trashed,
                                first: this.perPage
                            },
                            update(accommodationsSearch) {
                                this.listbox.listItems = Object.assign([], accommodationsSearch.accommodationsSearch.data)
                                this.listbox.listItems.forEach(item => {
                                    if (item.categories && item.categories.length > 0) item.color = item.categories[0].color;
                                });

                                return accommodationsSearch;
                            },

                        })
                    }
                } else {
                    this.$apollo.queries.accommodations.refresh()
                }
            },

        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
